import { render, staticRenderFns } from "./ExtracoesBdgdEstruturaBanco.vue?vue&type=template&id=429ff0ba&"
import script from "./ExtracoesBdgdEstruturaBanco.vue?vue&type=script&lang=js&"
export * from "./ExtracoesBdgdEstruturaBanco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VProgressCircular,VRow,VTextField,VTooltip,VTreeview})
